import { LinkEvent } from '../../store/LinkEvent';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

export const listLinkEvents = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters
  };

  return apiService.callExternalApi<PaginatedResponse<LinkEvent>>({
    url: buildAdvancedQueryURL(mergedFilters, 'link-events'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
